const pptLegend = {
    displayItems: ['player', 'speedAvg', 'speedMax', 'distance', 'distancePerShift', 'attackZonePercent'],
};

export default pptLegend;
